import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import Swal from "sweetalert2";
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  loginForm: any;
  submitted = false;
  postObj: any;
  constructor(
    private AuthenticationService: AuthenticationService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute
  ) {}
  ngOnInit(): void {
    this.loginForm = this.fb.group(
      {
        emailId: ["", [Validators.required]],
        password: ["", [Validators.required]],
      },
      {}
    );
  }
  get f() {
    return this.loginForm.controls;
  }
  onSubmit() {
    this.submitted = true;
    if (this.loginForm.valid) {
      this.postObj = {
        username: this.loginForm.value.emailId,
        password: this.loginForm.value.password,
        hostname: window.location.hostname,
      };
      // console.log("form data", this.postObj);
      this.AuthenticationService.login(this.postObj).subscribe(
        (response: any) => {
          // console.log("response --- " + response);
          // return false;
          const LoginResponse = response.data[0];
          if (response.code == 1) {
            localStorage.setItem("user_id", LoginResponse.user_id);
            localStorage.setItem("name", LoginResponse.name);
            localStorage.setItem("email", LoginResponse.email);
            localStorage.setItem("token", LoginResponse.token);
            localStorage.setItem("userType", LoginResponse.userType);
            localStorage.setItem("customerId", LoginResponse.customerId);
            localStorage.setItem("isMainUser", LoginResponse.isMainUser);
            localStorage.setItem("org_id", LoginResponse.organization_id);
            localStorage.setItem(
              "customerActionLogsId",
              LoginResponse.customerActionLogsId
            );
            this.setSessionExpire(LoginResponse.token);
            this.AuthenticationService.startUserStatusCheck();
            this.router.navigate(["/dash"]);
          } else {
            // this.flashMessage = "Something went wrong!";
            // this.flashType = "error";
            // this.flashActive = "flashblock";
            this.submitted = false;
            Swal.fire({
              title: "Warning!",
              text: response.message,
              icon: "warning",
              timer: 3000, // Time in milliseconds (e.g., 3000 ms = 3 seconds)
              // timerProgressBar: true, // Display a progress bar as the timer counts down
              // showConfirmButton: false, // Hide the "OK" button
            });
          }
        },(error:any)=>{
          this.submitted = false;
        }
      );
    } else {
      this.submitted = false;
    }
    window.scrollTo(0, 0);
  }

  recoverPassword() {
    this.router.navigate(["/recoverPassword"]);
  }

  private setSessionExpire(token: string) {
    //token expire time - from api it is 24 hours
    const expiresAt = JSON.parse(atob(token.split(".")[1])).exp * 1000;
    localStorage.setItem("expires_at", expiresAt.toString());

    //for testing purpose
    // const expiresAt = Date.now() + 2 * 60 * 1000; // 2 minutes in milliseconds
    // localStorage.setItem("access_token", token);
    // localStorage.setItem("expires_at", expiresAt.toString());
  }
}
